/* eslint-disable react/no-children-prop */
import { memo } from 'react';
import { Spinner } from 'reactstrap';
import FooterChart from './footerChart';
import { CHART_INFO } from './handler';
import HeaderChart from './headerChart';
import useHeatMapChart from './useHeatMapChart';
import './styles.scss';

export type HeatMapChartProps = {
  // activeTabState (Recoil/index.ts, Task 7) is typed as a broad union including TBeatHrActiveTab,
  // which is not assignable to a plain string - pre-existing gap, typed any here to match actual usage.
  activeButton: any;
};

/**
 * Renders the R-R interval heatmap panel with its header, plot area and footer. Reserves a fixed-height container for the chart library to draw into and overlays a spinner while useHeatMapChart reports the heatmap data is loading.
 *
 * @param props - Heatmap inputs including the active beat type, passed to useHeatMapChart and down to the header.
 * @returns The heatmap panel with its header, chart container and footer.
 */
const HeatMapChart = ({ activeButton }: HeatMapChartProps) => {
  const { isLoading } = useHeatMapChart({ activeButton });

  return (
    <div id="heat-map" className="heat-map-chart">
      <HeaderChart activeButton={activeButton} />
      {isLoading && (
        <div className="heatmap-loading">
          <Spinner className="heatmap-spinner" children="" />
        </div>
      )}
      <div
        id="heat-map-chart-id"
        style={{
          width: '100%',
          height: CHART_INFO.HEIGHT,
        }}
      />
      <FooterChart />
    </div>
  );
};

export default memo(HeatMapChart);
